<div class="row text-center">
  <span>{{ 'login.v2.msisdn_otp_instructions' | translate }}</span>
</div>
<form [formGroup]="form"
      [class.submitted]="submitted"
      (ngSubmit)="onSubmit()">
  <app-password-input formControlName="password"
                      [identifier]="identifier"
                      [formErrors]="formErrors"
                      [sendOnInit]="true"/>
  <button type="submit" class="btn btn-raised btn-block btn-primary">
    <span>{{ 'generic.button_next' | translate }}</span>
    @if (isLoading) {
      <i class="icon icon-spinner icon-spin"></i>
    }
  </button>
  <app-recaptcha-info/>
</form>
